import classNames from "classnames";
import React, { FC, useContext, useState } from "react";
import styles from "./PageActions.scss";

import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic/Icon";
import { Col, Row } from "../../grid";
import { AppContext } from "../../layout/AppContext";
import { Menu, MenuItem } from "../../navigation/Menu";
import { PopOver } from "../../navigation/PopOver";
import { Popup, PopupContent, PopupTitle } from "../../notify/Popup";
import { PageActionsTypes } from "./PageActions.types";



export const PageActions: FC<PageActionsTypes> = ({ title, icon, children }) => {
    const { pageInfo } = useContext(AppContext);
    const [visible, setVisible] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    return (
        <React.Fragment>
            <div
                className={classNames(styles.base, {
                    [styles.evadeButtons]: pageInfo.hasPageNav
                })}
            >
                <PopOver
                    padding="regular"
                    visible={visible}
                    content={renderMenuItems(children, setActiveItem, () => setVisible(false))}
                    onClose={() => setVisible(false)}
                >
                    <Clickable
                        className={classNames(styles.button, {
                            [styles.active]: visible
                        })}
                        onClick={() => setVisible(!visible)}
                    >
                        <div className={styles.label}>{title}</div>
                        <div className={styles.symbol}>
                            <Icon className={styles.icon} name={visible ? "close" : icon} />
                        </div>
                    </Clickable>
                </PopOver>
            </div>
            {activeItem ? (
                <Popup onClose={() => setActiveItem(null)}>
                    <PopupTitle>
                        {activeItem.props.icon ? (
                            <Row gutter={["small", "small"]}>
                                <Col align={["center", "center"]}>
                                    <Icon name={activeItem.props.icon} color="primary" size="large" />
                                </Col>
                                <Col grow>{activeItem.props.label}</Col>
                            </Row>
                        ) : null}
                    </PopupTitle>
                    <PopupContent>{activeItem.props.children}</PopupContent>
                </Popup>
            ) : null}
        </React.Fragment>
    );
};

const renderMenuItems = (items, setActiveItem, onClose) => {
    const handleItemClick = (child) => {
        onClose();
        if (React.Children.count(child.props.children) && !child.props.onClick) {
            setActiveItem(child);
        } else if (child.props.onClick) {
            child.props.onClick();
        }
    };

    return (
        <div className={styles.menu}>
            <Menu>
                {items &&
                    React.Children.map(items, (child, index) => (
                        <MenuItem
                            {...child.props}
                            key={index}
                            icon={child.props.icon}
                            label={child.props.label}
                            onClick={() => handleItemClick(child)}
                        />
                    ))}
            </Menu>
        </div>
    );
};

PageActions.defaultProps = {
    icon: "plus"
};
